module.exports = __webpack_public_path__ + "static/media/person_active.2a1faa91.svg";